import { Element } from "@craftjs/core";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { createRating } from "@/src/api/services/rating";
import { Action as Button } from "@/src/components/Action";
import { Title } from "@/src/components/Title";
import { Image } from "@/src/components/Image";
import { Card } from "@/src/components/Card";
import { FlexBox } from "@/src/components/FlexBox";
import { RatingInput } from "@/src/components/Fields/RatingField";
import { useProcessInstanceStore } from "@/src/stores/useProcessInstanceStore";
import { useUpdateField } from "@/src/hooks/useFieldDebouncedCallback";

interface RatingForm {
  rating: number;
}
export function RatingCard(props: any) {
  const {
    setValue: setValueParentForm,
    getValues: getValuesParentValue,
    watch,
  } = useFormContext();
  const form = useForm<RatingForm>();
  const { control, handleSubmit } = form;
  const orderId = useProcessInstanceStore(
    (state) => state.processInstance.order.id,
  );

  const updateContextField = useUpdateField();
  const mark = watch("rating");

  const { mutateAsync: createRatingMutation } = useMutation({
    mutationFn: createRating,
  });

  const onSubmit = async (payload: RatingForm) => {
    try {
      const mark = Object.values(payload)[0] || 0;
      await createRatingMutation({ mark, orderId });
      setValueParentForm("rating", mark);
      updateContextField("rating", mark);
    } catch (error) {
      console.error("Error submitting rating:", error);
    }
  };
  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Card
          {...{
            style: {
              "box-shadow": "0px 1px 6px 0px rgba(0, 0, 0, 0.12)",
              gap: "16px",
              borderRadius: "8px",
              background: "#FFFFFF",
              padding: "24px",
            },
          }}
          className={"m-auto md:w-[368px]"}
          key={mark}
          {...props}
        >
          {!mark ? (
            <Element
              is={FlexBox}
              canvas
              style={{ flexDirection: "column", gap: 24 }}
              id={`rating`}
            >
              <Element
                is={Title}
                id={"rating-title"}
                text={
                  "Нам важлива ваша думка,  будь ласка, оцініть наш сервіс!"
                }
                size={"h4"}
                background={"#234678"}
                textAlign={"center"}
              />
              <Element
                is={RatingInput}
                className={"w-full justify-center"}
                id={"rating-input"}
              />
              <Element
                is={Button}
                id={"rating-button"}
                variant={"contained"}
                methods={[{ method: "apicall_rating", params: ["mark"] }]}
                type={"submit"}
              >
                {"Оцінити"}
              </Element>
            </Element>
          ) : (
            <Element
              is={FlexBox}
              canvas
              style={{ flexDirection: "column", gap: 24 }}
              id={`thankYou`}
            >
              <Element
                is={Title}
                id={"thankYou-title"}
                text={"Дякуємо за відгук!"}
                size={"h4"}
                background={"#545C68"}
                textAlign={"center"}
              />
              <Element
                is={Image}
                id={"thankYou-image"}
                sizeMode={"size"}
                src={"/images/laptop_serce_ciemne.png"}
                width={180}
                height={100}
                alt="Лаптоп з серцем"
                objectFit={"contain"}
                style={{
                  boxShadow: "none",
                  aspectRatio: "180/102",
                }}
              />
              <Element
                is={Button}
                id={"thankYou-button"}
                variant={"contained"}
                methods={[{ method: "open_link", target: "_blank", href: "/" }]}
              >
                {"До магазину"}
              </Element>
            </Element>
          )}
        </Card>
      </form>
    </FormProvider>
  );
}
